import { createSelector } from 'reselect'

import { entityList$ } from 'syft-acp-core/reducers/generators/entities'

export const getManagers = createSelector(
  managersState => managersState,
  managers => entityList$(managers, {})
)
